module.exports = __webpack_public_path__ + "static/media/DevStory.3bda9e93.svg";